import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CookiesPage = () => {
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    // Sauvegarder les préférences (mock)
    localStorage.setItem('cookiePreferences', JSON.stringify(preferences));
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <section className="bg-[#E30022] text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl lg:text-4xl font-serif">Paramètres des cookies</h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8 lg:p-12">
          <p className="text-gray-600 mb-8">
            Nous utilisons des cookies pour améliorer votre expérience sur notre site. Vous pouvez personnaliser vos préférences ci-dessous.
          </p>

          {saved && (
            <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mb-6">
              Vos préférences ont été enregistrées.
            </div>
          )}

          <div className="space-y-6">
            {/* Cookies nécessaires */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Cookies nécessaires</h3>
                  <p className="text-gray-600 text-sm">
                    Ces cookies sont essentiels au fonctionnement du site et ne peuvent pas être désactivés. Ils permettent notamment la navigation sur le site et l'accès aux zones sécurisées.
                  </p>
                </div>
                <div className="ml-4">
                  <div className="w-12 h-6 bg-[#E30022] rounded-full relative cursor-not-allowed">
                    <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full"></div>
                  </div>
                  <span className="text-xs text-gray-500 mt-1 block">Toujours actif</span>
                </div>
              </div>
            </div>

            {/* Cookies analytiques */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Cookies analytiques</h3>
                  <p className="text-gray-600 text-sm">
                    Ces cookies nous permettent de mesurer l'audience du site et d'analyser le comportement des visiteurs afin d'améliorer nos services. Les données sont anonymisées.
                  </p>
                </div>
                <div className="ml-4">
                  <button
                    onClick={() => setPreferences({...preferences, analytics: !preferences.analytics})}
                    className={`w-12 h-6 rounded-full relative transition-colors ${preferences.analytics ? 'bg-[#E30022]' : 'bg-gray-300'}`}
                  >
                    <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${preferences.analytics ? 'right-1' : 'left-1'}`}></div>
                  </button>
                </div>
              </div>
            </div>

            {/* Cookies marketing */}
            <div className="border border-gray-200 rounded-lg p-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Cookies marketing</h3>
                  <p className="text-gray-600 text-sm">
                    Ces cookies sont utilisés pour vous proposer des publicités personnalisées en fonction de vos centres d'intérêt et pour mesurer l'efficacité de nos campagnes.
                  </p>
                </div>
                <div className="ml-4">
                  <button
                    onClick={() => setPreferences({...preferences, marketing: !preferences.marketing})}
                    className={`w-12 h-6 rounded-full relative transition-colors ${preferences.marketing ? 'bg-[#E30022]' : 'bg-gray-300'}`}
                  >
                    <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${preferences.marketing ? 'right-1' : 'left-1'}`}></div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <button
              onClick={handleSave}
              className="bg-[#E30022] text-white px-8 py-3 rounded hover:bg-[#c7001d] transition-colors font-medium"
            >
              Enregistrer mes préférences
            </button>
            <button
              onClick={() => {
                setPreferences({ necessary: true, analytics: true, marketing: true });
              }}
              className="border border-gray-300 text-gray-700 px-8 py-3 rounded hover:bg-gray-50 transition-colors font-medium"
            >
              Tout accepter
            </button>
            <button
              onClick={() => {
                setPreferences({ necessary: true, analytics: false, marketing: false });
              }}
              className="border border-gray-300 text-gray-700 px-8 py-3 rounded hover:bg-gray-50 transition-colors font-medium"
            >
              Tout refuser
            </button>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">En savoir plus sur les cookies</h2>
            <p className="text-gray-600 mb-4">
              Les cookies sont de petits fichiers texte stockés sur votre appareil lorsque vous visitez un site web. Ils permettent au site de mémoriser vos actions et préférences pendant une période déterminée.
            </p>
            <p className="text-gray-600">
              Pour plus d'informations sur notre utilisation des cookies, consultez notre <a href="/politique-confidentialite" className="text-[#E30022] hover:underline">politique de confidentialité</a>.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CookiesPage;
